var form = {
    selector: '.select_watch',
    init: function() {
        var self = this,
        $select = $( self.selector );

        $select.on( 'change', function() {
            if ( $( this ).val() !== '' ) {
                $( this ).addClass( 'has-value' );
            } else {
                $( this ).removeClass( 'has-value' );
            }
        });

        $select.find( 'option' ).each( function() {
            if ( $( this ).val() === '' ) {
                $( this ).attr( 'selected', true );
                $( this ).attr( 'disabled', true );
            }
        });
    }
}

export {
    form
};
